export default {
  FACEBOOK: '',
  INSTAGRAM: 'https://www.instagram.com/glorydaysbarberco',
  TWITTER: '',

  GOOGLE_MAPS_DIRECTIONS: 'https://www.google.com/maps/dir//Glory+Days+Barber+Co.+1435+South+Ave+Rochester,+NY+14620',
  SCHEDULICITY: 'https://www.schedulicity.com/scheduling/GDB57T2',
}